import React from "react";
import { Banner, EmptyBanner } from "../../stores/BannerStore";
import { Ad } from "./Ad";
import { renderBannerTeaser } from "./Teaser";
import { getAdImages, isEmptyBanner } from "../../utils/BannerUtil";

type PropType = {
    banner: Banner | EmptyBanner;
};

class HeroBanner extends React.Component<PropType> {
    renderPlaceHolder() {
        return (
            <div className="mfcss">
                <div className="mfcss_teaser-big" />
            </div>
        );
    }

    renderBanner(banner: Banner) {
        if (banner.advertisement) {
            return <Ad key={banner.placementId} images={getAdImages(banner)} className="margin-grid-top" />;
        }

        return renderBannerTeaser(banner, { className: "mfcss_teaser-big" });
    }

    render() {
        const banner = this.props.banner;
        if (isEmptyBanner(banner)) {
            return this.renderPlaceHolder();
        }
        return this.renderBanner(banner as Banner);
    }
}

export default HeroBanner;
